import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicoLandingPage from "../pages/servicos/ServicoLandingPage";
import PoliticaDePrivacidade from "../pages/politica-de-privacidade/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicos/:slug",
    element: <ServicoLandingPage />,
  },
  {
    path: "/politica-de-privacidade",
    element: <PoliticaDePrivacidade />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
